var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.003,
    height: 16.003,
    viewBox: "0 0 16.003 16.003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "pen",
    d: "M9.125-11.094l4,4L4.438,1.594.875,2a.763.763,0,0,1-.844-.844L.438-2.406Zm6.469-.594a1.447,1.447,0,0,1,.438,1.063,1.447,1.447,0,0,1-.437,1.063L13.813-7.781l-4-4,1.781-1.781A1.447,1.447,0,0,1,12.656-14a1.447,1.447,0,0,1,1.063.438Z",
    transform: "translate(-0.028 14)",
    fill: "#2a66bf"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.5a3e17ffe268b156ec7c3c1083c45dd7.svg";
export { ForwardRef as ReactComponent };